module.exports = __webpack_public_path__ + "img/iQiyi.bca90147.svg";